<template>
  <auth-template>
    <b-col md="5">
      <b-card-group>
        <b-card no-body class="p-4">
          <b-card-body>
            <b-form>
              <h1>Redirecionando...</h1>
            </b-form>
          </b-card-body>
        </b-card>
      </b-card-group>
    </b-col>
  </auth-template>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import SessionStorage from '@/services/session-storage'
import miniToastr from 'mini-toastr'

export default {
  name: 'Login',
  components: {
    AuthTemplate
  },
  data () {
    return {
    }
  },
  mounted () {
    console.log('-----------------------------------------------')
    console.log(SessionStorage.get('redirect-cadastro'))
    console.log(this.$route.query)
    this.callbackGov(this.$route.query.code)
    console.log('-----------------------------------------------')

    // this.callbackGov(this.$route.query.code)
  },
  methods: {
    callbackGov (code) {
      Vue.http.post('api/auth/' + code + '/web').then(response => {
      // Realiza o login caso exista o usuário
        if (response.body.data.login.token !== undefined) {
          if (response.body.data.login.situacao !== 'AT') {
            this.$router.push({path: '/'})

            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error('Seu usuário não está ativo!', 'Atenção', 6500)
            return true
          }
          SessionStorage.set('token', response.body.data.login.token)
          SessionStorage.set('perfil', response.body.data.login.perfil)
          SessionStorage.set('usuario', response.body.data.login.user)
          SessionStorage.setObject('permissoes', response.body.data.login.permissoes[0].permissoes)
          SessionStorage.setObject('tipoPerfil', response.data.data.login.permissoes[0].tipo_perfil)
          console.log(response.data.data.login.permissoes[0].tipo_perfil)
          if (response.data.data.login.permissoes[0].tipo_perfil === 'B' || response.data.data.login.permissoes[0].tipo_perfil === 'V') {
            console.log('teste')
            this.$router.push({path: '/aviso-app'})
            return true
          }
          this.$router.push({path: '/'})
          return true
        }

        if (response.body.data.login === false) {
          this.$router.push({path: '/'})
        }

        // Redireciona para completar o cadastro
        let redirect = SessionStorage.get('redirect-cadastro')
        let pathRedirect = false

        switch (redirect) {
          case 'beneficiaria':
            pathRedirect = '/cadastro-beneficiaria'
            break
          case 'voluntario':
            pathRedirect = '/cadastro-voluntario'
            break
          case 'gestor':
            pathRedirect = '/cadastro-gestor'
            break
          case 'tutor':
            pathRedirect = '/cadastro-tutor'
            break
          default:
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error('Usuário não cadastrado no sistema!', 'Atenção', 6500)
            this.$router.push({path: '/'})
            break
        }

        SessionStorage.setObject('dados-govbr', response.body.data)
        SessionStorage.remove('redirect-cadastro')
        this.$router.push({path: pathRedirect})
      }).catch(e => {})
    },
    redirectCadastro () {
      let redirect = SessionStorage.get('redirect-cadastro')
      switch (redirect) {
        case 'beneficiaria': //
          break
        case 'voluntario': //
          break
        case 'gestor': //
          break
        case 'tutor': //
          break
      }
    },
    redirecionar () {
      Vue.http.get('api/auth/govbr/login/web').then(response => {
        SessionStorage.set('redirect-cadastro', 'beneficiaria')
        let url = response.body.data.url
        location.href = url
      }).catch(e => {})
    }
  }
}
</script>

<style scoped>
.recaptchaBox {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/RedirectGov.vue